( function () {
    'use strict';
    espresso.searching = {};
    espresso.searching.init = function () {
        if ( co3.util.param.q !== undefined ) {
            //hvis der bliver s&oslash;gt sættes cursoren i s&oslash;gefeltet
            jQuery( '.form-search' ).first().find( 'input[name="q"]' ).focus().select();
            if ( !isNaN( parseInt( co3.util.param.searchpage ) ) ) {
                /*var jSearchForm = */
                jQuery( '.e-search, .form-search, .navbar-search' ).find( 'input[name="ID"]' ).val( co3.util.param.searchpage );
            }
            //byg bootstrap markup af dw's default paging
            var jSearchPaging = jQuery( '.pagination' );
            if ( jSearchPaging.length === 1 ) {
                jQuery( '.page-list a' ).wrap( function () {
                    var jListItem = jQuery( '<li></li>' );
                    if ( jQuery( this ).find( 'b' ).length > 0 ) {
                        return jListItem.addClass( 'active' );
                    }
                    else {
                        return jListItem;
                    }
                } );
                jSearchPaging.find( 'li' ).first().after( jQuery( '.page-list li' ) );
            }
        }
    };
}() );
